import type { GenerateQueryResponseDTO } from './types';

export function appendQueryVariables(generatedQuery: GenerateQueryResponseDTO, instancesSpaces?: string[]) {
  const queryVariables: Record<string, any> = generatedQuery.filter || {};

  if (instancesSpaces === undefined || instancesSpaces.length === 0) {
    return queryVariables;
  }

  const instanceSpaceFilter = {
    in: { property: ['node', 'space'], values: instancesSpaces },
  };

  if (Object.keys(queryVariables).length === 0) {
    return instanceSpaceFilter;
  }

  if ('and' in queryVariables) {
    queryVariables.and.push(instanceSpaceFilter);
    return queryVariables;
  }

  return { and: [queryVariables, instanceSpaceFilter] };
}
